import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#sonstigeausgabe

	{
        "antragstellerIds": [ String ],
        "betragMonatlich": BigDecimal
    }

*/
export const schemaEuropaceUpdateSonstigeAusgabe = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    betragMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdateSonstigeAusgabe = z.infer<typeof schemaEuropaceUpdateSonstigeAusgabe>;
